import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { customersComponentApi } from '../../../customers/store/services/customers';
import { OrganizationType } from '../../types';
import {
  BaseStatistics,
  CustomerStats,
  ProfitByCustomer,
} from '../../statistics/types';

export interface CustomerStatisticState {
  baseStatistic?: BaseStatistics[];
  profitByCustomer?: ProfitByCustomer;
  customerType?: OrganizationType;
  type?: 'base' | 'profit';
}

const initialState: CustomerStatisticState = {};

export const customerStatisticSlice = createSlice({
  name: 'customerStatistic',
  initialState,
  reducers: {
    setType: (state, action: PayloadAction<'base' | 'profit' | undefined>) => {
      state.type = action.payload;
    },
    clearStatisticState: (state) => {
      state.baseStatistic = undefined;
      state.profitByCustomer = undefined;
      state.customerType = undefined;
      state.type = undefined;
    },
  },
  extraReducers: (builder) => {
    builder.addMatcher(
      customersComponentApi.endpoints.getCustomerStats.matchFulfilled,
      (state, action: PayloadAction<{ data: CustomerStats }>) => {
        if (!state.type) {
          state.baseStatistic = action.payload.data.stats;
          state.profitByCustomer = {
            feesReceived: action.payload.data.feesReceived,
            turnover: action.payload.data.turnover,
            profitPercent: action.payload.data.profitPercent,
          };
        }

        if (state.type) {
          if (state.type === 'base') {
            state.baseStatistic = action.payload.data.stats;
          } else if (state.type === 'profit') {
            state.profitByCustomer = {
              feesReceived: action.payload.data.feesReceived,
              turnover: action.payload.data.turnover,
              profitPercent: action.payload.data.profitPercent,
            };
          }
        }
      },
    );
  },
});

export const { clearStatisticState, setType } = customerStatisticSlice.actions;

export default customerStatisticSlice.reducer;
